import React from 'react';
import { Content } from 'carbon-components-react';
import { SupportReqSuccess } from 'components';
import {
  selectSupportReqSubmitting,
  selectSupportRes
} from 'redux/user/selector';
import { selectIsFromSwxLocate } from 'redux/session/selectors';
import { useSelector } from 'react-redux';
import { useDeviceType } from 'customHooks/useDeviceType';

export interface PageProps {
  sideRailButtons?: Object;
  pageHeading?: string;
  pageDescription?: string;
}

/*
 * CUSTOM RIGHT HAND SIDE HEADER PANEL
 */
export const MainContainer: React.FC<PageProps> = (props: any) => {
  const { sideRailButtons, pageHeading, pageDescription } = props;
  const supportRes: any = useSelector(selectSupportRes);
  const isFromSwxLocate = useSelector(selectIsFromSwxLocate);
  const submitting: boolean = useSelector(selectSupportReqSubmitting);
  const { isMobileOrTablet } = useDeviceType();

  return props.children ? (
    <div
      className={`main-content--wrapper ${
        isFromSwxLocate ? 'locate-theme' : ''
      }`}
      style={isMobileOrTablet ? { height: '100%' } : {}}
    >
      <Content
        id="main-content"
        className={`${sideRailButtons ? 'sideRailMapNavActive' : ''}`}
        style={isMobileOrTablet ? { height: '100%' } : {}}
      >
        {(pageHeading || pageDescription) && (
          <section className="page-heading--wrapper">
            <h1 className="main-heading">{pageHeading || ''}</h1>
            <p className="main-description">{pageDescription || ''}</p>
          </section>
        )}
        {props.children}
        {!submitting && supportRes ? <SupportReqSuccess /> : null}
      </Content>
    </div>
  ) : null;
};
